export var TrackDirection;
(function (TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})(TrackDirection || (TrackDirection = {}));
//# sourceMappingURL=direction.js.map


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_rich_media/node_modules/smooth-scrollbar/track/direction.js
// module id = 307
// module chunks = 0